import { Link } from "react-router-dom";
import { ComingSoonImage } from "./ComingSoonImage";

export const MenuPreviewCard = ({ item }) => {
  const hasImage = item.image && item.image !== "COMING_SOON";

  return (
    <Link to={`/menu?plato=${item.id}`} className="menu-preview-card" data-testid={`featured-menu-card-${item.id}`} aria-label={`Ver ${item.name} en la carta`}>
      {hasImage ? (
        <img src={item.image} alt={item.name} data-testid={`featured-menu-image-${item.id}`} />
      ) : (
        <ComingSoonImage itemName={item.name} testId={`featured-menu-image-${item.id}`} />
      )}
      <div className="menu-overlay">
        <span data-testid={`featured-menu-tag-${item.id}`}>{item.tag}</span>
        <h3 data-testid={`featured-menu-name-${item.id}`}>{item.name}</h3>
      </div>
    </Link>
  );
};